module.exports = __webpack_public_path__ + "static/MR_Splash_Video-81f5ba64886b456d64abf1dd2d551e59.mp4";